import AutoLayout from '../../assets/images/about-autolayout.png'
import components from '../../assets/images/components-figma.png'
import web3 from '../../assets/images/web3.png'
import trends from '../../assets/images/2022.png'
import adobe from '../../assets/images/adobe.png'
import figma from '../../assets/images/figma-plugin.png'

export const articlesData = [
    {
        image: AutoLayout,
        title: "Autolayouts in Figma",
        description: "This is the subtitle of the article that would be edited into it, it should be max two line",
        date: "15/10/2022",
        readTime: "2 min",
        link:"https://bootcamp.uxdesign.cc/auto-layouts-in-figma-4240bea65435"
    },
    {
        image: components,
        title: "Components in Figma",
        description: "Hey everyone, in this article I’ll be taking a different approach from what I usually...",
        date: "16/9/2022",
        readTime: "2 min",
        link:"https://medium.com/@tobiegbude/components-in-figma-58ea4dcfe3da"
    },
    {
        image: web3,
        title: "Designing for Web 3.0",
        description: "Everyone seems to be talking about Web 3.0 how this is the new wave of the internet’s...",
        date: "5/7/2022",
        readTime: "5 min",
        link:"https://bootcamp.uxdesign.cc/designing-for-web-3-0-31a1f12781fd"
    },
    {
        image: trends,
        title: "2022 design trends: Yay or Nay",
        description: "In 2021 I wrote on Design trends: Yay or Nay, and even though not all trends...",
        date: "30/12/2021",
        readTime: "4 min",
        link:"https://bootcamp.uxdesign.cc/2022-design-trends-yay-or-nay-375e6f80eddf"
    },
    {
        image: adobe,
        title: "10 Great Adobe XD plugins for designers",
        description: "In my previous article, I spoke about great plugins for Figma...",
        date: "1/2/2021",
        readTime: "5 min",
        link:"https://uxplanet.org/10-great-adobe-xd-plugins-for-designers-aa766108f9df"
    },
    {
        image: figma,
        title: "10 Great Figma plugins for designers",
        description: "Figma is a decent tool, but there’s one thing that makes it a great tool, Figma Plugins...",
        date: "20/1/2021",
        readTime: "7 min",
        link:"https://uxplanet.org/10-great-figma-plugins-for-designers-b904c16f9d8f"
    }
]
